if (!customElements.get("video-scroll")) {
  class ComponentVideoScroll extends HTMLElement {
    constructor() {
      super();

      this.isPlaying = false;
      this.elBtnPlay = this.querySelector(".play");
      this.elBtnPause = this.querySelector(".pause");
      this.elVideo = this.querySelector(".video-element");
      this.mediaWrap = this.elVideo.closest(".media-wrap");
      this.progressBarContainer = this.mediaWrap.querySelector(".progress-bar-container");

      if (this.progressBarContainer) {
        this.elBtnPause.style.display = "none";
        this.elBtnPlay.style.display = "inline";
        this.initControls();
      } else {
        this.initControls();
        this.initObserver();
      }
    }
    initObserver() {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.isPlaying) {
            this.playVideo(true);
          } else if (!entry.isIntersecting && this.isPlaying) {
            this.playVideo(false);
          }
        });
      });
      this.observer.observe(this);
    }
    playVideo(play) {
      if (play) {
        this.elVideo.play();
        this.elBtnPlay.style.display = "none";
        this.elBtnPause.style.display = "inline";
        this.isPlaying = true;
      } else {
        this.elVideo.pause();
        this.elBtnPlay.style.display = "inline";
        this.elBtnPause.style.display = "none";
        this.isPlaying = false;
      }
    }
    initControls() {
      this.elBtnPlay.addEventListener("click", (event) => {
        event.preventDefault();
        this.playVideo(true);
      });
      this.elBtnPause.addEventListener("click", (event) => {
        event.preventDefault();
        this.playVideo(false);
      });
    }
  }
  customElements.define("video-scroll", ComponentVideoScroll);
}